import { render } from "./UploadImage.vue?vue&type=template&id=8314a744"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"

import "./UploadImage.vue?vue&type=style&index=0&id=8314a744&lang=css"
script.render = render

export default script